import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Home from './Home';
import PopAShot from './Pop-A-Shot';
import NotFound from './NotFound';
import logo from './code_and_theory_logo.png';
import cta_default from './cta_default.png';
import default_image from './default_image.png';
import art_frame from './art_frame.png';
import './App.css';
const file_saver = require('./FileSaver');

let image_link = "";
let image_key = "";
const getImage = () => {
  const url_string = window.location.href;
  const url = new URL(url_string);
  const params = new URLSearchParams(url.search);
  image_key = params.get("image");
  if (!image_key)
  {
    image_link = default_image;
  }
  else
  {
    image_link = "https://pop-a-shot-test.s3.us-west-1.amazonaws.com/" + image_key + ".png";
  }

};

function saveImage(){
  if (!image_key)
  {
    downloadImage(image_link, "pop-a-shot_cta_default" + ".png");
  }
  else
  {
    downloadImage(image_link, "pop-a-shot_" + image_key + ".png");
  }
}

async function downloadImage(imageSrc, image_name) {
  const image = await fetch(imageSrc)
  const imageBlog = await image.blob()
  const imageURL = URL.createObjectURL(imageBlog)

  const link = document.createElement('a')
  link.href = imageURL
  link.download = image_name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

function App() {
  return (
    <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pop-a-shot" element={<PopAShot />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
    </Router>
  );
}


export default App;
